var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { compose } from 'recompose';

import { withTheme } from 'grommet/es6/components/hocs';


import { StyledImageStamp } from './StyledImageStamp';

var SIZE_MAP = {
  small: 'medium',
  medium: 'large',
  large: 'xlarge',
  xlarge: 'xxlarge'
};

var ImageStamp = function (_Component) {
  _inherits(ImageStamp, _Component);

  function ImageStamp() {
    _classCallCheck(this, ImageStamp);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ImageStamp.prototype.render = function render() {
    var _props = this.props,
        size = _props.size,
        rest = _objectWithoutProperties(_props, ['size']);

    return this.props.src ? React.createElement(StyledImageStamp, _extends({ size: SIZE_MAP[size] }, rest)) : null;
  };

  return ImageStamp;
}(Component);

ImageStamp.defaultProps = {
  size: 'medium'
};


var ImageStampDoc = void 0;
if (process.env.NODE_ENV !== 'production') {
  ImageStampDoc = require('./doc').default(ImageStamp); // eslint-disable-line global-require
}

var ImageStampWrapper = compose(withTheme)(ImageStampDoc || ImageStamp);

export { ImageStampWrapper as ImageStamp };


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/ImageStamp/ImageStamp.js
// module id = 1159
// module chunks = 0